import { breakpoints, colors } from '../../style';
import { scale_d } from '../../helper/scaling';
import AntdTitle, { TitleProps as AntdTitleProps } from 'antd/lib/typography/Title';
import styled from 'styled-components';

interface InternalCustomTitleProps {
  color?: string;
  $noMargins?: boolean;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
}

const StyledAntdTitle = styled(AntdTitle)<InternalCustomTitleProps>`
  font-family: "Diazo Cond Bold";
  ${({ color }) => `color: ${color} !important;`}
  ${({ $noMargins }) => $noMargins ? "margin: 0 !important;" : ""}

  /* @media screen and (max-width: ${breakpoints.mobile}px) { */
    ${({ level }) => {
      switch (level) {
        case 1:
          return `font-size: 50px !important; line-height: 52px !important;`;
        case 2:
          return `font-size: 30px !important; line-height: 32px !important;`;
        case 3:
          return `font-size: 25px !important; line-height: 27px !important;`;
        case 4:
          return `font-size: 20px !important; line-height: 22px !important;`;
        case 5:
          return `font-size: 15px !important; line-height: 17px !important;`;
        case 6:  // Temporary workaronud for superscript
          return `font-size: 15px !important; line-height: 17px !important; vertical-align: super;`;
        default:
          return "";
      }
    }}
  /* } */

  /* @media screen and (min-width: ${breakpoints.mobile + 1}px) {
    ${({ level }) => {
      switch (level) {
        case 1:
            return `font-size: ${scale_d(140)} !important; line-height: ${scale_d(142)} !important;`;
          case 2:
            return `font-size: ${scale_d(102)} !important; line-height: ${scale_d(107)} !important;`;
          case 3:
            return `font-size: ${scale_d(80)} !important; line-height: ${scale_d(82)} !important;`;
          case 4:
            return `font-size: ${scale_d(60)} !important; line-height: ${scale_d(62)} !important;`;
          case 5:
            return `font-size: ${scale_d(45)} !important; line-height: ${scale_d(47)} !important;`;
          default:
            return "";
      }
    }}
  } */
`;

// @ts-expect-error Workaround for subscript level
export interface TitleProps extends AntdTitleProps {
  color?: "primary" | "secondary" | "tertiary" | "black" | "white";
  colorCode?: string;
  noMargins?: boolean;
  level?: 1 | 2 | 3 | 4 | 5 | 6;
}

/**
 * A Title component that supports our use of custom styles
 */
export default function Title({ children, color, colorCode, noMargins, ...props }: TitleProps) {
  const displayColorCode = colorCode ?? colors[color || "black"];
  return <StyledAntdTitle color={displayColorCode} $noMargins={noMargins} {...props}>{children}</StyledAntdTitle>;
}